var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-content',{attrs:{"code":"500","desc":"发生了不可知事件,程序猿正在加班中","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }